import React from 'react';
import { Avatar, Badge, Box } from '@mui/material';

/**
 * Extracts the first initial of the first and last name.
 */
const getInitials = (fullName) => {
  if (!fullName) return '';
  const names = fullName.trim().split(/\s+/);
  if (names.length === 1) return names[0].charAt(0).toUpperCase();
  return (names[0].charAt(0) + names[names.length - 1].charAt(0)).toUpperCase();
};

/**
 * Profile Menu Trigger
 * Displays a user's initials with a custom hamburger menu badge overlapping the outline.
 */
const ProfileMenuIcon = ({ userName }) => {
  return (
    <Badge
      overlap="circular"
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
      badgeContent={
        <Box
          sx={{
            backgroundColor: '#0A1929',
            padding: '2px 3px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            transform: 'translate(2px, 2px)',
            borderRadius: '4px',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              width: '14px',
              height: '9px',
            }}
          >
            <Box sx={{ height: '2px', backgroundColor: '#4facfe' }} />
            <Box sx={{ height: '2px', backgroundColor: '#4facfe' }} />
            <Box sx={{ height: '2px', backgroundColor: '#4facfe' }} />
          </Box>
        </Box>
      }
    >
      <Avatar
        sx={{
          background: 'linear-gradient(135deg, rgba(0, 0, 0, 0.2) 0%, rgba(0, 0, 0, 0.45) 100%)',
          boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.3)',
          color: '#ffffff', 
          border: '1.5px solid rgba(255, 255, 255, 0.15)', 
          fontWeight: 700,
          fontSize: '1.15rem',
          width: 44,
          height: 44,
          fontFamily: '"Inter", "Roboto", "Helvetica", sans-serif',
        }}
      >
        {getInitials(userName)}
      </Avatar>
    </Badge>
  );
};

export default ProfileMenuIcon;

